import Vue from 'vue'

const DASHBOARD = {
	ACCOUNTS: filter => {
		return Vue.$api.get('/dashboard/accounts')
	},
	INTERACTIONS_ADMIN: filter => {
		return Vue.$api.get('/dashboard/interactions', { params: filter })
	},
	INTERACTIONS_COMPETITORS: filter => {
		return Vue.$api.get('/dashboard/interactions/competitors', {
			params: filter,
		})
	},
	INTERACTIONS_COMPETITORS_USER: filter => {
		return Vue.$api.get('/dashboard/u/competitors', { params: filter })
	},
	INTERACTIONS_USER: filter => {
		return Vue.$api.get('/dashboard/u/interactions', { params: filter })
	},
	FOLLOWERS_USER: filter => {
		return Vue.$api.get('/dashboard/u/followers', { params: filter })
	},
	FOLLOWERS_ADMIN: filter => {
		return Vue.$api.get('/dashboard/followers', { params: filter })
	},
	STATS_USER: filter => {
		return Vue.$api.get('/dashboard/u/accountStats', { params: filter })
	},
	STATS: filter => {
		return Vue.$api.get('/dashboard/stats', { params: filter })
	},
	TOP: filter => {
		return Vue.$api.get('/posts/top', { params: filter })
	},
}

export default DASHBOARD
